import ApplicationConfirmModal from './ApplicationConfirmModal'

export default ApplicationConfirmModal